export const SECONDS_IN_A_DAY = 86400;

export const KRONOS_UNITS: { [k: number]: string } = {
  0: "h",
  1: "m",
  2: "s",
};
